var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"fixed"},model:{value:(_vm.tabActivo),callback:function ($$v) {_vm.tabActivo=$$v},expression:"tabActivo"}},[_c('vs-tab',{attrs:{"label":"📋 Encuestas"}},[_c('EncuestasProlipa')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }